import type { LaserPattern } from "./LaserPattern";
import type { ChargeFireContext, Direction } from "../../charges/Charge";

/**
 * Fires three beams: forward + perpendicular left/right.
 * With only cardinal directions available, "spread" is implemented as side beams.
 */
export class TripleBeamPattern implements LaserPattern {
  fire(ctx: ChargeFireContext): void {
    const shoot = ctx.shootLaser;
    if (!shoot) return;

    shoot(ctx.direction);
    shoot(relativeLeft(ctx.direction));
    shoot(relativeRight(ctx.direction));
  }
}

function relativeLeft(dir: Direction): Direction {
  switch (dir) {
    case "up":
      return "left";
    case "down":
      return "right";
    case "left":
      return "down";
    case "right":
      return "up";
  }
}

function relativeRight(dir: Direction): Direction {
  switch (dir) {
    case "up":
      return "right";
    case "down":
      return "left";
    case "left":
      return "up";
    case "right":
      return "down";
  }
}

export const tripleBeamPattern = new TripleBeamPattern();
